import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faSave,
  faBan,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import LoadingIndicator from "../../Loading/Loading";
import { NavDropdown, Tab, Tabs } from "react-bootstrap";
import { CategoryContext } from "../../../../context/categories";
import { TagsContext } from "../../../../context/tag";
import Modal from "../../Modal";
import Videos from "../../../VideoPage/Videos";
import Channels from "../../../Channels/Channels";
import { useSelectedVideos } from "../../../../context/selectedVideos";
import { SelectedChannelsProvider } from "../../../../context/selectedChannels";
import { ChannelContextProvider } from "../../../../context/channels";

function AdminTable({
  columns,
  data,
  onSave,
  onDelete,
  onCreate,
  actions = true,
  handleCheckboxChange,
  saveLoading,
  boxLocs,
  onLocationChange,
  onCategoryChange,
  onTagChange,
  onContentTypeChange,
  onBoxItemTypeChange,
}) {
  const [editingRow, setEditingRow] = useState(null);
  const [editingColumn, setEditingColumn] = useState(null);
  const [tempValue, setTempValue] = useState({});
  const { categories } = useContext(CategoryContext);
  const { tags } = useContext(TagsContext);
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [searchedText, setSearchedText] = useState("");
  const [tab, setTab] = useState("همه");
  const { setSelectedBox, setVideoType } = useSelectedVideos();
  // const [showCampaignMoreEdits, setShowCampaignMoreEdit] = useState(false);

  const handleCellClick = (rowIndex, columnKey) => {
    if (
      columnKey !== "box_location_name" &&
      columnKey !== "status" &&
      columnKey !== "box_name" &&
      columnKey !== "category_name" &&
      columnKey !== "tag_name" &&
      columnKey !== "content_type" &&
      columnKey !== "box_item_type"
    ) {
      setEditingRow(rowIndex);
      setEditingColumn(columnKey);

      setTempValue((prev) => ({
        ...prev,
        [`${rowIndex}-${columnKey}`]:
          prev[`${rowIndex}-${columnKey}`] || data[rowIndex][columnKey] || "",
      }));
    }
  };

  const handleSave = () => {
    if (editingRow !== null) {
      const updatedData = [...data];

      Object.keys(tempValue).forEach((key) => {
        const [rowIndex, columnKey] = key.split("-");

        if (parseInt(rowIndex) === editingRow) {
          updatedData[rowIndex][columnKey] = tempValue[key];
        }
      });

      onSave(updatedData[editingRow]);

      setEditingRow(null);
      setEditingColumn(null);
      setTempValue((prev) => {
        const updatedTempValue = { ...prev };
        Object.keys(updatedTempValue).forEach((key) => {
          const [rowIndex] = key.split("-");
          if (parseInt(rowIndex) === editingRow) {
            delete updatedTempValue[key];
          }
        });
        return updatedTempValue;
      });
    }
  };

  const handleCancel = () => {
    if (editingRow !== null) {
      setTempValue((prev) => {
        const updatedTempValue = { ...prev };
        Object.keys(updatedTempValue).forEach((key) => {
          const [rowIndex] = key.split("-");
          if (parseInt(rowIndex) === editingRow) {
            delete updatedTempValue[key];
          }
        });
        return updatedTempValue;
      });

      setEditingRow(null);
      setEditingColumn(null);
    }
  };

  const handleLocClick = (rowId, newLocation, rowIndex) => {
    onLocationChange(rowId, newLocation);
    setEditingRow(rowIndex);
    setEditingColumn("box_location_name");
  };

  const handleCatClick = (rowId, newCategory, rowIndex) => {
    const updatedData = [...data];
    updatedData[rowIndex].selectedCat = newCategory.id || null;
    onCategoryChange(rowId, newCategory);
    setEditingRow(rowIndex);
    setEditingColumn("category_name");
  };

  const handleTagClick = (rowId, newTag, rowIndex) => {
    const updatedData = [...data];
    updatedData[rowIndex].selectedTag = newTag.id || null;
    onTagChange(rowId, newTag);
    setEditingRow(rowIndex);
    setEditingColumn("tag_name");
  };

  const handleContentTypeClick = (rowId, newContentType, rowIndex) => {
    onContentTypeChange(rowId, newContentType);
    setEditingRow(rowIndex);
    setEditingColumn("content_type");

    setSelectedType(newContentType);
  };

  const handleBoxItemTypeClick = (rowId, newBoxItemType, rowIndex) => {
    setSelectedBox(rowId);
    onBoxItemTypeChange(rowId, newBoxItemType);
    setEditingRow(rowIndex);
    setEditingColumn("box_item_type");

    setSelectedType(data.filter((item) => item.id === rowId)[0].content_type);

    setVideoType(selectedType);

    if (newBoxItemType.fa === "دستی") {
      setShowGalleryModal(true);
    }
  };

  const handleStatusClick = (rowIndex) => {
    handleCheckboxChange(rowIndex);
    setEditingRow(rowIndex);
    setEditingColumn("status");
  };

  useEffect(() => {
    if (selectedType) setVideoType(selectedType);
  }, [selectedType, setVideoType]);

  return (
    <div
      style={{
        paddingRight: "15px",
        paddingLeft: "15px",
        width: "100%",
      }}
    >
      {onCreate && (
        <button className="adminBtnCreate" onClick={onCreate}>
          ساخت گزینه جدید
        </button>
      )}
      <div className="adminTableContainer">
        <table className="adminDataTable">
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col.key}
                  style={{ paddingRight: col.key === "box_name" && "8px" }}
                >
                  {col.label}
                </th>
              ))}
              {actions && <th></th>}
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      style={{ paddingRight: col.key === "box_name" && "8px" }}
                    >
                      {editingRow === rowIndex &&
                      editingColumn === col.key &&
                      col.key !== "status" &&
                      col.key !== "box_location_name" &&
                      editingColumn !== "item_count" &&
                      col.key !== "category_name" &&
                      col.key !== "tag_name" &&
                      col.key !== "content_type" &&
                      col.key !== "box_item_type" ? (
                        <input
                          type="text"
                          value={tempValue[`${rowIndex}-${col.key}`] || ""}
                          onChange={(e) =>
                            setTempValue((prev) => ({
                              ...prev,
                              [`${rowIndex}-${col.key}`]: e.target.value,
                            }))
                          }
                          autoFocus
                          style={{
                            outline: "none",
                            width: col.key === "cach_time" && "50px",
                          }}
                        />
                      ) : col.key === "status" ? (
                        <div
                          className={`custom-checkboxx ${
                            row[col.key] === true
                              ? "checked"
                              : row[col.key] === false
                              ? "error"
                              : "empty"
                          }`}
                          onClick={() => handleStatusClick(rowIndex)}
                        ></div>
                      ) : col.key === "box_location_name" ? (
                        <NavDropdown
                          style={{
                            height: "50%",
                            width: "fit-content",
                            textAlign: "right",
                          }}
                          title={row.selectedLoc}
                          id=""
                          className="mx-1 no-arrow adminTableDropdownCon"
                        >
                          {boxLocs.map((item, index) => (
                            <div
                              key={index}
                              className="adminTableDropdown"
                              onClick={() =>
                                handleLocClick(
                                  row.id,
                                  { id: item.id, name: item.name },
                                  rowIndex
                                )
                              }
                            >
                              {item.name}
                            </div>
                          ))}
                        </NavDropdown>
                      ) : col.key === "item_count" ? (
                        editingRow === rowIndex &&
                        editingColumn === "item_count" ? (
                          <input
                            type="number"
                            value={tempValue[`${rowIndex}-${col.key}`] || ""}
                            min={1}
                            max={
                              row.box_name === "ویدئوهای ویژه"
                                ? 10
                                : row.box_name === "جدیدترین ویدئوها"
                                ? 12
                                : row.box_name === "ردیف نخست ویدئوها"
                                ? 6
                                : row.box_name === "ردیف دوم ویدئوها"
                                ? 6
                                : row.box_name === "کانال ها"
                                ? 10
                                : row.box_name === "ردیف سوم ویدئوها"
                                ? 6
                                : row.box_name === "ردیف چهارم ویدئوها"
                                ? 6
                                : row.box_name === "کانال های ویژه"
                                ? 10
                                : row.box_name === "ردیف پنجم ویدئوها"
                                ? 6
                                : row.box_name === "ردیف ششم ویدئوها" && 6
                            }
                            onChange={(e) =>
                              setTempValue((prev) => ({
                                ...prev,
                                [`${rowIndex}-${col.key}`]: e.target.value,
                              }))
                            }
                            autoFocus
                            style={{ outline: "none", width: "50px" }}
                          />
                        ) : (
                          <span
                            onClick={() => handleCellClick(rowIndex, col.key)}
                            style={{ cursor: "pointer" }}
                          >
                            {row[col.key]}
                          </span>
                        )
                      ) : col.key === "category_name" ? (
                        <NavDropdown
                          style={{
                            height: "50%",
                            width: "fit-content",
                            textAlign: "right",
                          }}
                          title={row.selectedCat}
                          id=""
                          className="mx-1 no-arrow adminTableDropdownCon"
                        >
                          <div
                            className="adminTableDropdown"
                            onClick={() =>
                              handleCatClick(
                                row.id,
                                { id: null, name: "" },
                                rowIndex
                              )
                            }
                          >
                            هیچکدام
                          </div>
                          {categories?.map((item, index) => (
                            <div
                              key={index}
                              className="adminTableDropdown"
                              onClick={() =>
                                handleCatClick(
                                  row.id,
                                  { id: item.id, name: item.name },
                                  rowIndex
                                )
                              }
                            >
                              {item.name}
                            </div>
                          ))}
                        </NavDropdown>
                      ) : col.key === "tag_name" ? (
                        <NavDropdown
                          style={{
                            height: "50%",
                            width: "fit-content",
                            textAlign: "right",
                          }}
                          title={row.selectedTag}
                          id=""
                          className="mx-1 no-arrow adminTableDropdownCon"
                        >
                          <div
                            className="adminTableDropdown"
                            onClick={() =>
                              handleTagClick(
                                row.id,
                                { id: null, name: "" },
                                rowIndex
                              )
                            }
                          >
                            هیچکدام
                          </div>
                          {tags.results?.map((item, index) => (
                            <div
                              key={index}
                              className="adminTableDropdown"
                              onClick={() =>
                                handleTagClick(
                                  row.id,
                                  { id: item.id, name: item.name },
                                  rowIndex
                                )
                              }
                            >
                              {item.name}
                            </div>
                          ))}
                        </NavDropdown>
                      ) : col.key === "content_type" ? (
                        <NavDropdown
                          style={{
                            height: "50%",
                            width: "fit-content",
                            textAlign: "right",
                          }}
                          title={row.selectedContentType}
                          id=""
                          className="mx-1 no-arrow adminTableDropdownCon"
                        >
                          {["video", "channel", "audio", "campaign"].map(
                            (item, index) => (
                              <div
                                key={index}
                                className="adminTableDropdown"
                                onClick={() =>
                                  handleContentTypeClick(row.id, item, rowIndex)
                                }
                              >
                                {item}
                              </div>
                            )
                          )}
                        </NavDropdown>
                      ) : col.key === "box_item_type" ? (
                        <NavDropdown
                          style={{
                            height: "50%",
                            width: "fit-content",
                            textAlign: "right",
                          }}
                          title={row.selectedBoxItemType}
                          id=""
                          className="mx-1 no-arrow adminTableDropdownCon"
                        >
                          {[
                            { fa: "دستی", en: "by hand" },
                            { fa: "اتوماتیک", en: "atuo" },
                          ].map((item, index) => (
                            <div
                              key={index}
                              className="adminTableDropdown"
                              onClick={() => {
                                handleBoxItemTypeClick(row.id, item, rowIndex);
                              }}
                            >
                              {item.fa}
                            </div>
                          ))}
                        </NavDropdown>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          {/* {row[col.key] === "پویش" && (
                            <button
                              className="adminMoreEdit"
                              title="تنظیمات بیشتر"
                              onClick={() => setShowCampaignMoreEdit(true)}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                          )} */}
                          <span
                            onClick={() => handleCellClick(rowIndex, col.key)}
                            style={{
                              display: "flex",
                              minHeight: "10px",
                              cursor: col.key !== "box_name" && "pointer",
                            }}
                          >
                            {editingRow === rowIndex &&
                            tempValue[`${rowIndex}-${col.key}`] !== undefined
                              ? tempValue[`${rowIndex}-${col.key}`]
                              : row[col.key]}
                          </span>
                        </div>
                      )}
                    </td>
                  ))}
                  {actions && (
                    <td style={{ display: "flex" }}>
                      {editingRow === rowIndex ? (
                        <>
                          <button className="adminBtnSave" onClick={handleSave}>
                            {saveLoading ? (
                              <LoadingIndicator />
                            ) : (
                              <FontAwesomeIcon icon={faSave} />
                            )}
                          </button>
                          <button
                            className="adminBtnCancel"
                            onClick={handleCancel}
                          >
                            <FontAwesomeIcon icon={faBan} />
                          </button>
                        </>
                      ) : (
                        <button
                          className="adminBtnDelete"
                          onClick={() => onDelete(row)}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length + (actions ? 1 : 0)}>
                  داده ای وجود ندارد.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal
        isOpen={showGalleryModal}
        onClose={() => setShowGalleryModal(false)}
      >
        <div style={{ width: "90vw" }}>
          <input
            style={{
              marginTop: "20px",
              padding: "2px 5px",
            }}
            onChange={(e) => setSearchedText(e.target.value)}
            placeholder="جستجو..."
          />
          <Tabs
            id="controlled-tab-example"
            activeKey={tab}
            onSelect={(k) => setTab(k)}
            className="mt-3"
          >
            <Tab
              eventKey="همه"
              title={
                selectedType === "channel" ? "همه کانال ها" : "همه ویدئوها"
              }
            >
              {selectedType === "channel" ? (
                <SelectedChannelsProvider>
                  <ChannelContextProvider>
                    <Channels
                      paddingRight={false}
                      select={true}
                      searchedText={searchedText}
                      tab={tab}
                      limitedCardNumber={data[editingRow]?.item_count}
                    />
                  </ChannelContextProvider>
                </SelectedChannelsProvider>
              ) : (
                <Videos
                  all={true}
                  searchedText={searchedText}
                  tab={tab}
                  categoryName={data[editingRow]?.category_id}
                  tagName={data[editingRow]?.tag_id}
                  limitedCardNumber={data[editingRow]?.item_count}
                  videoType={selectedType}
                  campaignName={data[editingRow]?.box_name}
                />
              )}
            </Tab>
            <Tab
              eventKey={
                selectedType === "channel"
                  ? "کانال های منتخب"
                  : "ویدئوهای منتخب"
              }
              title={
                selectedType === "channel"
                  ? "کانال های منتخب"
                  : "ویدئوهای منتخب"
              }
            >
              {selectedType === "channel" ? (
                <SelectedChannelsProvider>
                  <ChannelContextProvider>
                    <Channels
                      paddingRight={false}
                      select={true}
                      searchedText={searchedText}
                      tab={tab}
                      limitedCardNumber={data[editingRow]?.item_count}
                    />
                  </ChannelContextProvider>
                </SelectedChannelsProvider>
              ) : (
                <Videos
                  all={true}
                  searchedText={searchedText}
                  tab={tab}
                  categoryName={data[editingRow]?.category_id}
                  tagName={data[editingRow]?.tag_id}
                  boxId={data[editingRow]?.id}
                  limitedCardNumber={data[editingRow]?.item_count}
                  videoType={selectedType}
                  campaignName={data[editingRow]?.box_name}
                />
              )}
            </Tab>
          </Tabs>
        </div>
      </Modal>
    </div>
  );
}

AdminTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onCreate: PropTypes.func,
  actions: PropTypes.bool,
  saveLoading: PropTypes.bool,
};

export default AdminTable;
